enum AccountConstants {
  ADD_ACCOUNT_REQ = "ADD_ACCOUNT_REQ",
  ADD_ACCOUNT_SUCCESS = "ADD_ACCOUNT_SUCCESS",
  ADD_ACCOUNT_FAILURE = "ADD_ACCOUNT_FAILURE",

  GET_SINGLE_CLIENT_REQUEST = "GET_SINGLE_CLIENT_REQUEST",
  GET_SINGLE_CLIENT_SUCCESS = "GET_SINGLE_CLIENT_SUCCESS",
  GET_SINGLE_CLIENT_FAILURE = "GET_SINGLE_CLIENT_FAILURE",

  GET_CLIENTS_REQUEST = "GET_CLIENTS_REQUEST",
  GET_CLIENTS_SUCCESS = "GET_CLIENTS_SUCCESS",
  GET_CLIENTS_FAILURE = "GET_CLIENTS_FAILURE",

  GET_ALL_CLIENTS_REQUEST = "GET_ALL_CLIENTS_REQUEST",
  GET_ALL_CLIENTS_SUCCESS = "GET_ALL_CLIENTS_SUCCESS",
  GET_ALL_CLIENTS_FAILURE = "GET_ALL_CLIENTS_FAILURE",

  GET_CLIENT_TYPES_REQUEST = "GET_CLIENT_TYPES_REQUEST",
  GET_CLIENT_TYPES_SUCCESS = "GET_CLIENT_TYPES_SUCCESS",
  GET_CLIENT_TYPES_FAILURE = "GET_CLIENT_TYPES_FAILURE",

  GET_SIGNUP_CATEGORY_REQUEST = "GET_SIGNUP_CATEGORY_REQUEST",
  GET_SIGNUP_CATEGORY_SUCCESS = "GET_SIGNUP_CATEGORY_SUCCESS",
  GET_SIGNUP_CATEGORY_FAILURE = "GET_SIGNUP_CATEGORY_FAILURE",

  EDIT_CLIENT_INFO_REQUEST = "EDIT_CLIENT_INFO_REQUEST",
  EDIT_CLIENT_INFO_SUCCESS = "EDIT_CLIENT_INFO_SUCCESS",
  EDIT_CLIENT_INFO_FAILURE = "EDIT_CLIENT_INFO_FAILURE",

  EDIT_CLIENT_FILTER_REQUEST = "EDIT_CLIENT_FILTER_REQUEST",
  EDIT_CLIENT_FILTER_SUCCESS = "EDIT_CLIENT_FILTER_SUCCESS",
  EDIT_CLIENT_FILTER_FAILURE = "EDIT_CLIENT_FILTER_FAILURE",

  GET_IS_CLIENT_SHARE_EXIST_REQUEST = "GET_IS_CLIENT_SHARE_EXIST_REQUEST",
  GET_IS_CLIENT_SHARE_EXIST_SUCCESS = "GET_IS_CLIENT_SHARE_EXIST_SUCCESS",
  GET_IS_CLIENT_SHARE_EXIST_FAILURE = "GET_IS_CLIENT_SHARE_EXIST_FAILURE",

  GET_CLIENT_ADJUSTMENT_AMOUNT_REQUEST = "GET_CLIENT_ADJUSTMENT_AMOUNT_REQUEST",
  GET_CLIENT_ADJUSTMENT_AMOUNT_SUCCESS = "GET_CLIENT_ADJUSTMENT_AMOUNT_SUCCESS",
  GET_CLIENT_ADJUSTMENT_AMOUNT_FAILURE = "GET_CLIENT_ADJUSTMENT_AMOUNT_FAILURE",

  GET_NO_PAGE_ADJUSTMENT_AMOUNT_REQUEST = "GET_NO_PAGE_ADJUSTMENT_AMOUNT_REQUEST",
  GET_NO_PAGE_ADJUSTMENT_AMOUNT_SUCCESS = "GET_NO_PAGE_ADJUSTMENT_AMOUNT_SUCCESS",
  GET_NO_PAGE_ADJUSTMENT_AMOUNT_FAILURE = "GET_NO_PAGE_ADJUSTMENT_AMOUNT_FAILURE",

  PAYMENT_WITH_ADJUSTMENT_REQUEST = "PAYMENT_WITH_ADJUSTMENT_REQUEST",
  PAYMENT_WITH_ADJUSTMENT_SUCCESS = "PAYMENT_WITH_ADJUSTMENT_SUCCESS",
  PAYMENT_WITH_ADJUSTMENT_FAILURE = "PAYMENT_WITH_ADJUSTMENT_FAILURE",

  RESET_EXISTED_CLIENT_SHARE_CLIENT = "RESET_EXISTED_CLIENT_SHARE_CLIENT",
  RESET_CLIENT_FILTER_EDIT_ERROR = "RESET_CLIENT_FILTER_EDIT_ERROR",
  RESET_CLIENT = "RESET_CLIENT",
  RESET_CLIENTS = "RESET_CLIENTS",
}

export default AccountConstants;
